import { useMutation, useQuery } from "urql";

import { graphql } from "@/gen";

export const useVideo = (videoId: string | null) => {
    const [result, refetch] = useQuery({
        query: graphql(`
            query videoQuery($id: UUID!) {
                video(id: $id) {
                    id
                    ...UpdateVideoForm_Video
                }
            }
        `),
        variables: {
            id: videoId ?? "",
        },
        pause: videoId == null,
    });

    return {
        video: result.data?.video,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};

export const useDeleteVideoMutation = () => {
    return useMutation(
        graphql(`
            mutation useDeleteVideoMutation_deleteVideo($id: UUID!) {
                deleteVideo(id: $id)
            }
        `)
    );
};

export const UpdateVideoForm_Video = graphql(`
    fragment UpdateVideoForm_Video on Video {
        id
        thumbnailImageId
        muxPlaybackId
        title
        youtubeId
    }
`);
